import SelectField from '../../../../../Components/Form/components/SelectField';
import React from 'react';
import { useVatRatesQuery } from '../../../../../graphql/graphql';
import Loading from '../../../../../Components/Loading';

interface Props {
	name: string;
	label?: string;
	isRequired?: boolean;
}

const SelectVatRateField = ({ name, label, isRequired }: Props) => {
	const { data, isLoading } = useVatRatesQuery();

	if (isLoading) {
		return <Loading />;
	}

	const vatRateOptions = (data?.termItems?.data || []).map(vatRate => ({
		value: vatRate?.value || '',
		label: vatRate?.name || '',
	}));

	return (
		<SelectField
			name={name}
			label={label}
			options={vatRateOptions}
			isRequired={isRequired}
		/>
	);
};

export default SelectVatRateField;
